import React, { useEffect, useState, useContext } from 'react'
import PageHeader from '../helper/PageHeader';
import { useHistory, useParams } from 'react-router'
import SimpleTable from '../helper/SimpleTable';
import Loading from '../helper/Loading';
import axios from 'axios';
import { withTranslation } from 'react-i18next';
import {RefundInitiate} from '../helper/Dialogs';
import { authContext } from '../../context/AuthContext';

import { trainingCost } from '../../constants/global'

const AdminEmployerPurchase = props => {

    const {t} = props; 
    const tableCells = [
        // { id: 'id', label: 'ID', centered: false },
        { id: 'confirmationNumber', label: t('PurchaseTransactions.Confirmation') , centered: false },
        { id: 'documentNumber', label: t('PurchaseTransactions.Document') , centered: false },
        { id: 'submittedDate', label: t('PurchaseTransactions.PurchaseDate'), centered: false },
        { id: 'transactionAmount', label: t('PurchaseTransactions.TransactionAmount'), centered: false },
        { id: 'submittedAmount', label: t('PurchaseTransactions.SubmittedAmount'), centered: false },
        { id: 'statusDescription', label: t('PurchaseTransactions.Status'), centered: false },
    ];


    const history = useHistory()   
    const params = useParams()
    const context = useContext(authContext)

    const [data, setData] = useState(null);

    const [clickedID, setClickedId] = useState(null);

    const [name, setName] = useState('')

    const [error, setError] = useState(false)

    const [errorMessage, setErrorMessage] = useState('')

    const [addCredit, setAddCredit] = useState({amount: trainingCost, reason: 'Refunded to Card', transId: '', requestDate: '', transactionAmount: 0});

    const current = new Date();
    const date = `${current.getMonth()+1}/${current.getDate()}/${current.getFullYear()}`;
    
    async function getData() {
        let res = await axios.get('/api/ipay/transactions/employer/'+ params.employerID, {
        });
        console.log('res.data',res.data);
         res.data.forEach(e => {
          e.actionsDisabled = {
            allowRefund: (e.transactionStatus === 0) 
           }
        });
        setData(res.data);
        console.log('res.data', res.data)

        let employer = await axios.get('/api/usergroup/'+ params.employerID, {});
            console.log('employer', employer)
            setName(employer.data.usergroup.name);    
  
    }

    useEffect(() => {
        
        getData();
    // render only once
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

    const deductChecked = (event) => {
        setAddCredit( prev => {return {...prev, deductCredit: event.target.checked  }});
    }

    const onRefund = async (id) => {
        const course = data.find(e => e.id === id)
        console.log(course);
        setClickedId(course.id);
        setAddCredit( prev => {return {...prev, transId: course.id }});
        setAddCredit( prev => {return {...prev, requestDate: date }});
        setAddCredit( prev => {return {...prev, transactionAmount: course.transactionAmount }});
      
        handleClickOpen();
    }

    const handleReason = (event) => {
        event.persist()
        
        setAddCredit( prev => {return {...prev, reason: event.target.value}})
    }

    const handleAmount = (event) => {
        event.persist()
        console.log('event target',event.target.value);
        console.log(' transactionAmount ', addCredit.transactionAmount );

        if(event.target.value > 0 && event.target.value <= addCredit.transactionAmount){
            setAddCredit( prev => {return {...prev, amount: event.target.value}})
        }
        
    }

    const handleRefundClick = async () => {
        
        console.log('data to be sent to server', addCredit );

        let byUserName = context.user.username;
        let token = context.accessToken;

        console.log('data to be sent to server', addCredit );

        let data = {
            amount:parseInt(addCredit.amount),
            notes: addCredit.reason,
            byUsername: byUserName,
            originalTransactionID: addCredit.transId,
            deductCredit: addCredit.deductCredit

        }

        console.log('from employer',data);
        try{
        await axios('/api/credit/refund/employer/' + params.employerID, {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        })
        handleClose()
        getData()
    }
    catch(err){
        console.log('error from here', err.response.statusText)
            setErrorMessage( err.response.statusText)
            setError(true)
    }
       


    }

    const actionButtons = [
        { label: 'Refund', action: onRefund, delete: false, view: 'allowRefund' },
    ];

    return (
        <>
            <PageHeader title={ name + ' '+ t('PurchaseTransactions.MyPurchaseHistory')} cancel={history.goBack} />
            {data === null ? <Loading /> :
                data.length === 0 ? <h1>{t('PurchaseTransactions.NoDataFound')}</h1> :
                    <>
                        
                        <RefundInitiate 
                        open={open}
                        onClose={handleClose}
                        date = {date}
                        transId = {clickedID}
                        onAmountChange={handleAmount}
                        onReasonChange={handleReason}
                        onRefundClick = {handleRefundClick}
                        presentAmountValue = {addCredit.amount}
                        CheckedValue = {addCredit.deductCredit}
                        onChangeDeductCredit = {deductChecked}
                        mainError = {errorMessage}
                        error = {error}
                        />
                        <SimpleTable
                            data={data}
                            cellKey={"id"}
                            tableCells={tableCells}
                            actionButtons={actionButtons}
                            actions={true}
                        />
                    </>
            }

        </>
    )
}

export default withTranslation()(AdminEmployerPurchase);